import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  color: ${brand.primary.blue};

  svg {
    ${transition('transform')};

    display: block;
    width: 8px;
    height: 15px;
    position: absolute;
    top: 50%;
    right: ${fluid(24, 42)};
    transform: translateY(-50%) rotate(90deg);
    pointer-events: none;
    color: currentColor;
  }

  &[data-open='true'] {
    svg {
      transform: translateY(-50%) rotate(270deg);
    }
  }
`;
const Select = styled.select `
  ${transition('border-radius')};
  ${fonts.apparat.bold};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background-color: ${brand.white};
  border: 2px solid currentColor;
  border-radius: 50px;
  height: ${fluid(45, 54)};
  font-size: ${fluid(16, 18)};
  margin: 0;
  padding: 7px ${fluid(46, 64)} 7px ${fluid(24, 42)};
  width: 100%;
  color: currentColor;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  ${Container}[data-open='true'] & {
    border-radius: 25px 25px 0 0;
  }

  &[data-error='true'] {
    border-color: ${brand.validation.invalid};
  }
`;
const DropdownStyles = {
    Container,
    Select,
};
export default DropdownStyles;
